module.exports = __webpack_public_path__ + "img/settings_1920.ea62ab8f.png";